

import logo from 'assets/LogoInsurance.jpg'
import { useState } from 'react';
import { Dialog } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import { Protect, SignedIn, SignedOut, UserButton } from '@clerk/clerk-react';
// import Cookies from 'js-cookie'
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useEffect } from 'react'
import { useViewDataStore } from '@/defines/store/viewDataStore';

const navigation = {
    base: [
        { name: '首頁', href: '/' },
        { name: '關懷事項', href: '/care/care' },
    ],
}


export default function CareTeamNavbar() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const location = useLocation();

    useEffect(() => {
        console.log(`[CareTeamNavbar] location.state?.message: ${location.state?.message}`);
        if (location.state?.message) {
            toast.error(location.state.message);
        }
        console.log(`[CareTeamNavbar] useViewDataStore.message: ${useViewDataStore.getState().messageAfterRedirect}`);
        if (useViewDataStore.getState().messageAfterRedirect) {
            toast.error(useViewDataStore.getState().messageAfterRedirect);
            useViewDataStore.setState({ messageAfterRedirect: '' });
        }
    }, [location]);

    return (
        <div className="bg-white">
            <header className="relative inset-x-0 top-0 z-10">
                <nav
                    className="flex items-center justify-between p-6 lg:px-8"
                    aria-label="Global"
                >
                    <div className="flex lg:flex-1">
                        <a href="/" className="-m-1.5 p-1.5">
                            <span className="sr-only">關懷團隊</span>
                            <img
                                className="w-auto h-14 sm:h-18 md:h-20 lg:h-22"
                                src={logo}
                                alt="保險醫友"
                            />
                        </a>
                    </div>
                    <div className="flex lg:hidden">
                        <div>
                            <p className="m-3 text-2xl font-bold tracking-tight text-center text-gray-900 sm:text-2xl md:text-3xl">
                                關懷之友
                            </p>
                            <p className="m-3 text-base font-bold tracking-tight text-center text-gray-900 sm:text-2xl md:text-3xl">
                                客戶滿意 您亦受益
                            </p>
                        </div>
                    </div>
                    <div className="flex lg:hidden">
                        <button
                            type="button"
                            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
                            onClick={() => setMobileMenuOpen(true)}
                        >
                            <span className="sr-only">Open main menu</span>
                            <Bars3Icon
                                className="w-6 h-6"
                                aria-hidden="true"
                            />
                        </button>
                    </div>
                    <div className="hidden lg:flex lg:gap-x-12">
                        {navigation.base.map((item) => (
                            <a
                                key={item.name}
                                href={item.href}
                                className="text-lg font-semibold leading-6 text-gray-900"
                            >
                                {item.name}
                            </a>
                        ))}
                    </div>
                    <div className="hidden lg:flex lg:flex-1 lg:justify-end">
                        <SignedOut>
                            {/* <SignInButton /> */}
                            <Link
                                to="/login"
                                className="rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold 
                                text-red-400 shadow-sm hover:bg-red-100 outline outline-red-400 outline-1"
                            >
                                登入
                            </Link>
                        </SignedOut>
                        <SignedIn>
                            <UserButton />
                        </SignedIn>
                    </div>
                </nav>
                <Dialog
                    as="div"
                    className="lg:hidden"
                    open={mobileMenuOpen}
                    onClose={setMobileMenuOpen}
                >
                    <div className="fixed inset-0 z-50" />
                    <Dialog.Panel className="fixed inset-y-0 right-0 z-50 w-full px-6 py-6 overflow-y-auto bg-white sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
                        <div className="flex items-center justify-between">
                            <a href="#" className="-m-1.5 p-1.5">
                                <img
                                    className="w-auto h-14 sm:h-18 md:h-20 lg:h-22"
                                    src={logo}
                                    alt="關懷之友"
                                />
                            </a>
                            <button
                                type="button"
                                className="-m-2.5 rounded-md p-2.5 text-gray-700"
                                onClick={() => setMobileMenuOpen(false)}
                            >
                                <span className="sr-only">Close menu</span>
                                <XMarkIcon
                                    className="w-6 h-6"
                                    aria-hidden="true"
                                />
                            </button>
                        </div>
                        <div className="flow-root mt-6">
                            <div className="-my-6 divide-y divide-gray-500/10">
                                <div className="py-6 space-y-2">
                                    {navigation.base.map((item) => (
                                        <a
                                            key={item.name}
                                            href={item.href}
                                            onClick={() =>
                                                setMobileMenuOpen(false)
                                            }
                                            className="block px-3 py-2 -mx-3 text-lg font-semibold leading-7 text-gray-900 rounded-lg hover:bg-gray-50"
                                        >
                                            {item.name}
                                        </a>
                                    ))}

                                    <Protect
                                        condition={(has) => has({ role: 'org:anesthes_content_manager' }) || has({ role: 'org:medicalcenter_content_manager' }) || has({ role: 'org:admin' })}
                                    >
                                        <a key="admin" href="/admin/personal-info"
                                            className="block px-3 py-2 -mx-3 text-lg font-semibold leading-7 text-gray-900 rounded-lg hover:bg-gray-50">
                                            管理介面
                                        </a>
                                    </Protect>
                                </div>
                                <SignedOut>
                                    <a
                                        key=''
                                        href='/login'
                                        className="text-lg font-semibold leading-6 text-gray-900"
                                    >
                                        登入
                                    </a>
                                </SignedOut>
                                <SignedIn>
                                    <UserButton />
                                </SignedIn>
                            </div>
                        </div>
                    </Dialog.Panel>
                </Dialog>
            </header>
        </div>
    );
}
